import { Button, Checkbox } from '@today/ui-primitives'
import type { ReactElement } from 'react'

/** The warning's built-in copy; override any entry for localisation. */
export interface ChannelMismatchWarningLabels {
	confirm: string
	changeMessage: string
}

/**
 * Props for {@link ChannelMismatchWarning}.
 *
 * @property message - The worded warning, naming the template's channel.
 * @property confirmed - Whether "Send with this message anyway" is ticked.
 */
export interface ChannelMismatchWarningProps {
	message: string
	confirmed: boolean
	onConfirmedChange: (confirmed: boolean) => void
	onChangeMessage: () => void
	labels?: Partial<ChannelMismatchWarningLabels>
}

const DEFAULT_LABELS: ChannelMismatchWarningLabels = {
	confirm: 'Send with this message anyway',
	changeMessage: 'Change message',
}

/**
 * Offer Wizard Step 4's channel-mismatch warning (TO-140 offer-notification-message
 * REQ-109): the worded warning, the "send anyway" confirmation and a way back to
 * Step 3. Pure.
 */
export function ChannelMismatchWarning(props: ChannelMismatchWarningProps): ReactElement {
	const labels = { ...DEFAULT_LABELS, ...props.labels }
	return (
		<div
			role="status"
			className="flex flex-col gap-3 rounded-ds-md border border-ds-border bg-ds-surface-muted p-4 text-ds-sm text-ds-text"
		>
			<p>{props.message}</p>
			<div className="flex flex-wrap items-center gap-4">
				<Checkbox isSelected={props.confirmed} onChange={props.onConfirmedChange}>
					<span className="text-ds-sm text-ds-text">{labels.confirm}</span>
				</Checkbox>
				<Button size="sm" variant="secondary" onPress={props.onChangeMessage}>
					{labels.changeMessage}
				</Button>
			</div>
		</div>
	)
}
